export default __webpack_public_path__ + "static/media/Slider_3500_Web.c6692e49.webp";